<div class="container col-sm-8 pt-5 webview text-center">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
    {{ question }}
  </h1>
  <div class="col-sm-12">
    <div class="d-flex m-auto col-sm-6 col-md-6 col-xl-8">
      <div class="col-6 q-cards">
        <label
          class="card card-list pt-5 text-center d-inline-block pull-right"
          for="Standard Switch"
        >
          <label for="Standard Switch" class="mt-3 pt-4">Standard Switch</label>
          <p>(3-7 Business Days)</p>
          <div
            class="
              custom-control custom-checkbox
              boxchkbox
              chkbox
              shadow-none
              mb-2
            "
          >
            <input
              type="checkbox"
              class="custom-control-input"
              [disabled]="isDisable"
              id="Standard Switch"
              value="Standard Switch"
              [(ngModel)]="hgSwitch.value1"
              name="typeOfSwitch"
              (change)="getSwitchDate($event)"
            />
            <label class="custom-control-label" for="Standard Switch"></label>
          </div>
        </label>
      </div>
      <div class="col-6 q-cards">
        <label
          class="card card-list text-center w-100 pt-5 d-inline-block pull-left"
          for="Self-Selected Switch"
        >
          <label for="Self-Selected Switch" class="mt-3 pt-4"
            >Self-Selected Switch</label
          >
          <p>(choose a date)</p>
          <div
            class="
              custom-control custom-checkbox
              boxchkbox
              chkbox
              shadow-none
              mb-2
            "
          >
            <input
              type="checkbox"
              class="custom-control-input"
              [disabled]="isDisable"
              id="Self-Selected Switch"
              value="Self-Selected Switch"
              [(ngModel)]="hgSwitch.value2"
              name="typeOfSwitch"
              (change)="getSwitchDate($event)"
            />
            <label
              class="custom-control-label"
              for="Self-Selected Switch"
            ></label>
          </div>
        </label>
      </div>
    </div>
  </div>
  <p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
    <a href="javascript:void(0)" (click)="openModal(template)">
      {{ questionObj.chkboxtype }}</a
    >
  </p>
  <button *ngIf="showbutton" 
    class="btn next mr-2 ml-2 mt-4 disabledButton mt-2 font22 text-uppercase"
    [ngClass]="{ sectbtn: user_bot }"
    [disabled]="isDisable"
    (click)="next()"
  >
    Next
  </button>
  <br />
  <div class="mt-5" [hidden]="!isDisable">
    <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr">
      <img src="assets/images/flash.png" class="mb-1" />
      <p class="text-center tiphead">TIP OF THE DAY</p>
      <p class="text-center tipmes">{{ questionObj.tip }}</p>
    </div>
  </div>
  <p class="primary" [hidden]="!isDisable">
    Click to
    <a class="business_link" (click)="ignore()">"ignore and proceed"</a> or quit
    the application by clicking
    <a class="business_link" (click)="signUp()"
      >"Thanks for letting me know. I'll check back soon."</a
    >
  </p>
</div>
<div class="container mobileview mt-2 px-0 mb-3" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <div class="row m-auto">
    <div class="col-12 d-flex mx-auto text-center mr-0 pr-0">
      <div class="col-6 box-shadow-none">
        <label
          class="card card-list text-center d-inline-block p-2 w-100"
          for="Standard Switch_mob"
          style="height: 125px"
        >
          <label for="Standard Switch_mob">Standard Switch</label>
          <p>(3-7 Business Days)</p>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input
              type="checkbox"
              class="custom-control-input"
              [disabled]="isDisable"
              id="Standard Switch_mob"
              value="Standard Switch"
              [(ngModel)]="hgSwitch.value1"
              name="typeOfSwitch"
              (change)="getSwitchDate($event)"
            />
            <label
              class="custom-control-label"
              for="Standard Switch_mob"
            ></label>
          </div>
        </label>
      </div>
      <div class="col-6 box-shadow-none">
        <label
          class="card card-list text-center d-inline-block p-2 w-100"
          for="Self-Selected Switch_mob"
          style="height: 125px"
        >
          <label for="Self-Selected Switch_mob">Self-Selected Switch</label>
          <p>(choose a date)</p>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input
              type="checkbox"
              class="custom-control-input"
              [disabled]="isDisable"
              id="Self-Selected Switch_mob"
              value="Self-Selected Switch"
              [(ngModel)]="hgSwitch.value2"
              name="typeOfSwitch"
              (change)="getSwitchDate($event)"
            />
            <label
              class="custom-control-label"
              for="Self-Selected Switch_mob"
            ></label>
          </div>
        </label>
      </div>
    </div>
    <p class="m-auto text-muted tapmsg" style="color: #0055ff !important">
      <a (click)="openModal(template)">{{ questionObj.chkboxtype }}</a>
    </p>
    <div class="mt-5" [hidden]="!isDisable">
      <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
        <img
          src="assets/images/flash.png"
          class="mb-1"
          style="margin-left: 48%"
        />
        <p class="text-center tiphead">TIP OF THE DAY</p>
        <p class="text-center tipmes">{{ questionObj.tip }}</p>
        <!-- <p class="text-center font-weight-bold">TIP OF THE DAY<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
      </div>
    </div>
    <p class="primary mt-1" [hidden]="!isDisable">
      Click to
      <a class="business_link" (click)="ignore()">"ignore and proceed"</a> or
      quit the application by clicking
      <a class="business_link" routerLink="/signup" routerLinkActive="active"
        >"Thanks for letting me know. I'll check back soon."</a
      >
    </p>
    <div class="col-121" style="width: 94% !important; text-align: right">
      <div *ngIf="user_bot" class="ash_box text-right mt-2 mb-2">
        <h1 class="ansMob text-right">{{ typeOfSwitch }}</h1>
      </div>
    </div>
  </div>
  <ng-template #template>
    <div class="modal-header py-0">
      <div class="col-12 text-right py-0 px-0 modal-border">
        <button
          type="button"
          class="close pull-right borderNone closeModelAlign"
          aria-label="Close"
          (click)="modalRef.hide()"
        >
          <div _ngcontent-c5="" class="float-right mr-1 mt-1">
            <img src="assets/images/editchart-close.svg" width="17" />
          </div>
        </button>
        <br />
        <h4 class="modal-title pull-left semi-bold font20">
          Move In and Switch Fees by Utility
        </h4>
      </div>
    </div>
    <div class="modal-body">
      <p class="font15 font-weight-normal-calibre">
        This fee schedule reflects what you could be charged from your local
        Utility to start new service or switch providers. These prices are
        subject to change. Please check with your respective Utility for the
        most-up-to-date pricing.
      </p>
      <div class="row">
        <div class="col-md-6 col-6">
          <p class="font15 calibre-semibold mb-0">New Service</p>
          <p class="font15 font-weight-normal-calibre">
            <span>Standard Move In</span><br />
            <span class="calibre-italic"
              >At least 2 days after time of enrollment</span
            >
          </p>
          <p class="font15 font-weight-normal-calibre">
            <span>Priority Move In</span><br />
            <span class="calibre-italic"
              >Power needs to be turned on within 24-48 hours</span
            >
          </p>
        </div>
        <div class="col-md-6 col-6">
          <p class="font15 calibre-semibold mb-0">Switching Providers</p>
          <p class="font15 font-weight-normal-calibre">
            <span>Standard Switch</span><br />
            <span class="calibre-italic"
              >3-7 Business Days after enrollment</span
            >
          </p>
          <p class="font15 font-weight-normal-calibre">
            <span>Self-Select Switch</span><br />
            <span class="calibre-italic"
              >More than 7 business days in the future</span
            >
          </p>
        </div>
      </div>
      <div class="rounded webview">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="font15 semi-bold text-center">TDSP</th>
              <th scope="col" class="font15 semi-bold text-center">Move In</th>
              <th scope="col" class="font15 semi-bold text-center">
                Priority Move In
              </th>
              <th scope="col" class="font15 semi-bold text-center">
                Self-Select Switch
              </th>
              <th scope="col" class="font15 semi-bold text-center last">
                Standard Switch<br />(3 - 7 Business Days)
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="font15 font-weight-normal-calibre text-center"
              *ngIf="tduRates.length === 0"
            >
              Please wait for updated plan details
            </tr>
            <tr *ngFor="let element of tduRates; let i = index">
              <td class="font15 font-weight-normal-calibre text-center">
                {{ loadActualUtilityName[element.Abbreviation] }}
              </td>
              <td class="font15 font-weight-normal-calibre text-center">
                ${{ checkForWholeOrDecimal(element.MoveInFee) }}
              </td>
              <td class="font15 font-weight-normal-calibre text-center">
                ${{ checkForWholeOrDecimal(element.PriorityMoveInFee) }}
              </td>
              <td class="font15 font-weight-normal-calibre text-center">
                ${{ checkForWholeOrDecimal(element.SwitchFee) }}
              </td>
              <td class="font15 font-weight-normal-calibre text-center">
                $0.00
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="rounded mobileview text-center"
        style="float: left; width: 100%"
      >
        <div style="float: left; width: 50%">
          <table class="table" style="display: inline-block">
            <thead>
              <tr>
                <th scope="col" class="font15 semi-bold text-center">TDSP</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  AEP Central
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  AEP North
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  Centerpoint
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  NEC
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  Oncor
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  Sharyland Utility
                </td>
              </tr>
              <tr>
                <td class="font15 font-weight-normal-calibre text-center">
                  TNMP
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="float: left; width: 50%">
          <table class="table" style="display: inline-block">
            <thead
              style="height: 50px !important; vertical-align: middle !important"
            >
              <tr class="p-0">
                <th scope="col" class="font15 semi-bold text-center last">
                  <a
                    (click)="prevTab()"
                    class="pull-left"
                    *ngIf="tableIndex != 0"
                    ><img src="assets/images/left-arrow.png"
                  /></a>
                  {{ tableElements[tableIndex].thead }}
                  <a
                    (click)="nextTab()"
                    class="pull-right"
                    *ngIf="tableIndex != 3"
                    ><img src="assets/images/right-arrow.png"
                  /></a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let element of rowElements; let i = index">
                <td class="font15 font-weight-normal-calibre text-center last">
                  {{ element }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>
</div>
